import { type VehicleDerivedTag } from '../types/cache-tags';

const getVehicleDerivedTags = (vehicleIds: number[]): VehicleDerivedTag[] => [
  ...vehicleIds.map((vehicleId) => ({ type: 'Vehicles' as const, id: vehicleId })),
  ...vehicleIds.map((vehicleId) => ({ type: 'VehiclePolyline' as const, id: vehicleId })),
  ...vehicleIds.map((vehicleId) => ({ type: 'VehicleEnergyPreview' as const, id: vehicleId })),
];

export default getVehicleDerivedTags;
